module.exports = __webpack_public_path__ + "media/images/default/default_user_icon_type_3-66f0892be4a11d8894e94f41b125dccf.png";